import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from "@angular/forms";
import { FieldModel, GenericFormService } from "@cv-invision/cv.invision-views.ux";
import { Subject } from "rxjs";

@Component({
	selector: 'cv-radio-button-field',
	templateUrl: './radio-button-field.component.html',
	styleUrls: [ './radio-button-field.component.scss' ],
})
export class RadioButtonFieldComponent implements OnInit {
	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: FieldModel;
	@Input() value: any;
	options: any;
	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor(
		private formService: GenericFormService
	) {

	}

	ngOnInit(): void {
		this.options = this.field.options;

		if(this.field.disabled){
			this.control.disable();
		}
	}
}
